export function shouldDecreaseTextSize(
  text?: string,
  totalLengthBreakpoint = 45,
  wordLengthBreakpoint = 12,
) {
  if (!text) return false;
  return (
    text.length >= totalLengthBreakpoint ||
    text.split(" ").some((word) => word.length >= wordLengthBreakpoint)
  );
}

const LOWERCASE_WORDS = new Set(["and", "or", "of", "the", "in", "a", "an"]);

export function toTitleCase(str: string): string {
  return str
    .split(" ")
    .map((word, i) =>
      i === 0 || !LOWERCASE_WORDS.has(word.toLowerCase())
        ? word.charAt(0).toUpperCase() + word.slice(1)
        : word.toLowerCase(),
    )
    .join(" ");
}

export function formatPersonName(name: string): string {
  const comma = name.indexOf(",");
  return comma > 0
    ? `${name.slice(comma + 1).trim()} ${name.slice(0, comma).trim()}`
    : name;
}
